import React from 'react'
import { Platform } from 'react-native'

import { Stack, YStack } from '@zet/design-system/layout'
import { B3, B4, SH3 } from '@zet/design-system/typography'
import { i18n } from '@zet/localization'
import moment from 'moment'

import { ApplicationAsk, LeadDetailsType } from '../types'
import { ShareVKYCPendingReminder } from './shareVKYCPendingReminder'

type ActionRequiredProps = {
  item?: LeadDetailsType
  ocAsk?: ApplicationAsk
  videoData?: {
    en: {
      thumbnail: string
      url: string
      video_id: string
    }
    hi: {
      thumbnail: string
      url: string
      video_id: string
    }
  }
}

const ActionRequired = ({ item, ocAsk, videoData }: ActionRequiredProps) => {
  if (ocAsk?.isResolved) {
    return (
      <Stack className="bg-grays-20 mx-3 rounded">
        <YStack className="px-4/2 py-2">
          {ocAsk?.updatedDate ? (
            <B4 className="text-grays-50">
              {i18n.t('leads.completedOn', {
                createdDate: moment(ocAsk?.updatedDate)
                  .utc()
                  .format('DD-MMM-YYYY'),
              })}
            </B4>
          ) : (
            <B4 className="text-grays-50">
              {i18n.t('leads.completedOn', {
                createdDate: moment(ocAsk?.createdDate)
                  .utc()
                  .format('DD-MMM-YYYY'),
              })}
            </B4>
          )}
          <B3 className="text-grays-50">
            {ocAsk?.title ? ocAsk?.title : ocAsk?.description}
          </B3>
        </YStack>
      </Stack>
    )
  } else {
    return (
      <Stack
        className={`${
          item?.hasNoUpdate ? 'bg-warning-10' : 'bg-secondary-10'
        } mx-3 my-2 rounded`}
      >
        <YStack className="pt-2">
          <Stack className="px-4/2">
            {Boolean(ocAsk?.createdDate) && (
              <B4 className="text-grays-60">
                {moment.utc(ocAsk?.createdDate).format('DD-MMM-YYYY')}
              </B4>
            )}
            {Boolean(ocAsk?.title) && (
              <SH3 className="text-grays-80">{ocAsk?.title}</SH3>
            )}
            {Boolean(ocAsk?.description) && (
              <B3 className="text-grays-60">{ocAsk?.description}</B3>
            )}
            {Boolean(ocAsk?.remarks) && (
              <B4 className=" bg-neutral-white100 mt-2 rounded p-2">
                {ocAsk?.remarks}
              </B4>
            )}
          </Stack>

          {ocAsk?.showYoutubeVideo && Platform.OS !== 'web' && (
            <ShareVKYCPendingReminder
              customerName={item?.name}
              customerPhoneNumber={item?.phoneNumber}
              videoData={videoData}
              isWarningIntent={item?.hasNoUpdate}
              leadId={item?.id}
              partnerId={item?.partnerId}
            />
          )}
        </YStack>
      </Stack>
    )
  }
}

export default ActionRequired
